import { createSelector } from '@reduxjs/toolkit'
import { RootState } from "../../"

export const editSidebarOpen = createSelector(
  (state: RootState) => state.editSidebar,
  (editSidebar) => ({ show: editSidebar.show })
)
